import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('RecommendedButton').create(({ theme }) => ({
  root: {
    border: `1px solid ${theme.colors.borders.secondary}`,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: theme.sizes.texts.fontSize.m,
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',

    gap: theme.sizes.texts.fontSize.l,
    p: {
      margin: 0,
      padding: 0,
      lineHeight: theme.sizes.texts.fontSize.l,
      fontSize: theme.sizes.texts.fontSize.l,
      color: theme.colors.text.primary,
      fontWeight: 550,
    },
  },
}))
